import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Ribbon from "@/components/landing/Ribbon";
import Divisions from "@/components/landing/Divisions";
import Specs from "@/components/landing/Specs";
import ContactCallback from "@/components/landing/ContactCallback";
import Footer from "@/components/landing/Footer";
import IntroOverlay from "@/components/landing/IntroOverlay";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#F4F1EB] text-[#1A2118]">
      <IntroOverlay />
      <Navbar />
      <Hero />
      <Manifesto />
      <Ribbon />
      <Divisions />
      <Specs />
      <ContactCallback />
      <Footer />
    </main>
  );
}
